export default __webpack_public_path__ + "static/media/institutionAdd.fd083940.svg";